/**
 * PageHero — a wide banner image used at the top of each main page.
 * All photos feature Black and Brown men (curated Unsplash portraits).
 *
 * Layout: full-width landscape banner ~260px mobile / 320px desktop, image fills
 * (`object-cover`). Per-photo `objectClass` uses responsive Tailwind arbitrary values so
 * the desktop crop (thin horizontal slice) and the mobile crop (~square) BOTH keep the
 * man's face visible.
 */

// Per-photo responsive `object-position` classes (mobile → desktop).
// Format examples: `object-[50%_22%]` = position 22% down on mobile; `lg:object-[50%_38%]` = 38% on desktop.
const PHOTOS = {
  home:         { id: "1585490931726-a7784b1575a5", credit: "Logan Weaver",   pos: "object-[50%_22%] lg:object-[50%_20%]" },
  journal:      { id: "1531384441138-2736e62e0919", credit: "Unsplash",       pos: "object-[50%_28%] lg:object-[50%_32%]" },
  learn:        { id: "1525357816819-392d2380d821", credit: "Sammy Williams", pos: "object-[60%_35%] lg:object-[60%_35%]" },
  coach:        { id: "1615813967515-e1838c1c5116", credit: "Unsplash",       pos: "object-[50%_22%] lg:object-[50%_30%]" },
  progress:     { id: "1615813967515-e1838c1c5116", credit: "Unsplash",       pos: "object-[50%_22%] lg:object-[50%_30%]" },
  plans:        { id: "1599070306640-28f961d4f89c", credit: "Erick Reyes",    pos: "object-[50%_22%] lg:object-[50%_18%]" },
  support:      { id: "1507003211169-0a1dd7228f2d", credit: "Unsplash",       pos: "object-[50%_25%] lg:object-[50%_34%]" },
  resources:    { id: "1531384441138-2736e62e0919", credit: "Unsplash",       pos: "object-[50%_28%] lg:object-[50%_32%]" },
  workshops:    { id: "1599070306640-28f961d4f89c", credit: "Erick Reyes",    pos: "object-[50%_22%] lg:object-[50%_18%]" },
  podcast:      { id: "1585490931726-a7784b1575a5", credit: "Logan Weaver",   pos: "object-[50%_22%] lg:object-[50%_20%]" },
  subscription: { id: "1531384441138-2736e62e0919", credit: "Unsplash",       pos: "object-[50%_28%] lg:object-[50%_32%]" },
};

export default function PageHero({ photo, alt, className = "", testid }) {
  const cfg = PHOTOS[photo];
  if (!cfg) return null;
  const src = `https://images.unsplash.com/photo-${cfg.id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800`;
  return (
    <div
      data-testid={testid || `page-hero-${photo}`}
      className={`relative w-full h-[260px] lg:h-[320px] rounded-3xl overflow-hidden mb-6 lg:mb-8 bg-navy ${className}`}
    >
      <img
        src={src}
        alt={alt || "Man of color reflecting"}
        loading="lazy"
        className={`w-full h-full object-cover ${cfg.pos}`}
      />
      {/* Subtle bottom gradient for polish */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(11,25,44,0) 45%, rgba(11,25,44,0.32) 100%)",
        }}
      />
    </div>
  );
}
